import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const hasOnlyNumbers = /^[0-9]*$/; //NOSONAR
export const validPIN = (control: FormControl) => {
    if (hasOnlyNumbers.test(control.value)) {
        return null;
    }

    return { invalidPIN: messages.validation.invalidPIN };
};
